
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisAtonMobilePhysicalIec as ObiAisAtonMobilePhysicalIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-aton-mobile-physical-iec.js';
 
 
 

 
 export const ObiAisAtonMobilePhysicalIec = createComponent({
   react: React,
   tagName: 'obi-ais-aton-mobile-physical-iec',
   elementClass: ObiAisAtonMobilePhysicalIecElement,
   events: {
     
   }
  });
 
 